import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-section-left',
  templateUrl: './mini-section-left.component.html',
  styleUrls: ['./mini-section-left.component.scss']
})
export class MiniSectionLeftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
